module.exports = __webpack_public_path__ + "static/media/logo_new.9e3705a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/logo_new.svg
// module id = 1275
// module chunks = 0